import React, { useState } from "react";
import "./ImagePlaceholderComponentStyle.scss";
import { IS_SCREENS_MODE } from "../../../../config/appMode";
import { buildSrcSet, variantsFor } from "../../../../utils/image";

// La imagen principal del detalle ocupa la columna col-lg-7/col-xl-8 y se topa en ~987px.
// Con este `sizes` el navegador elige la variante segun ancho x densidad de pantalla.
const DETAIL_IMAGE_SIZES = "(min-width: 1440px) 987px, (min-width: 992px) 60vw, 100vw";

export const ImageWithBlurPlaceholder = ({ image, car, isFirst = false }: any) => {
    const [isLoaded, setIsLoaded] = useState(false);
    // srcSet solo si el backend ya genero variantes para esta imagen; si no, cae al `src`.
    const srcSet = buildSrcSet(variantsFor(car?.imageSrcsetByKey, image));

    return (
        <div className="img-wrapper">
            {!isLoaded && <div className="img-skeleton" />}
            <img
                src={image}
                srcSet={srcSet}
                sizes={srcSet ? DETAIL_IMAGE_SIZES : undefined}
                alt={car?.name}
                title={car?.name}
                className="img-fluid w-100 image-desktop-car-component"
                loading={isFirst ? "eager" : "lazy"}
                fetchPriority={isFirst ? "high" : "auto"}
                onLoad={() => setIsLoaded(true)}
                style={{
                    objectFit: IS_SCREENS_MODE ? "cover" : "fill",
                    borderRadius: "8px",
                    opacity: isLoaded ? 1 : 0,
                    transition: "opacity 0.45s ease-out",
                }}
            />
            <img
                src={image}
                srcSet={srcSet}
                sizes={srcSet ? "100vw" : undefined}
                alt={car?.name}
                title={car?.name}
                className="img-fluid w-100 image-mobile-car-component"
                loading={isFirst ? "eager" : "lazy"}
                onLoad={() => setIsLoaded(true)}
                style={{
                    objectFit: IS_SCREENS_MODE ? "cover" : "fill",
                    borderRadius: "8px",
                    opacity: isLoaded ? 1 : 0,
                    transition: "opacity 0.45s ease-out",
                }}
            />
        </div>
    );
};
